import { graphql } from "gatsby"
import { withTranslation } from 'gatsby-plugin-react-i18next'
import React, { Component } from 'react'

import Layout from '../components/layout'
import Seo from '../components/seo'
import Hero from '../components/landing/hero/Hero'
import Guide from '../components/landing/guide/Guide'
import Faq from '../components/landing/faq/Faq'
import Contact from '../components/landing/contact/Contact'
import DiscountPopup from '../components/landing/discount-popup/DiscountPopup'

import { mapFAQToStructuredData } from '../services/functions'

const seoContent = {
  title: 'Secure Self Storage Units For Rent',
  description: 'Find the secure self storage facility near you!  Our self storage units include climate controlled storage, RV storage, 5x5 storage, and 10x10 storage.',
}
class HomePage extends Component {
  render() {
    const { t, pageContext } = this.props
    const googleStructuredData = [{
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": mapFAQToStructuredData(t(`landing:faq.sections`, { returnObjects: true }))
    }]
    return (
      <Layout
        page="Landing"
        pageContext={pageContext}
        footerBorderTop={false}
      >
        <Seo 
          {...seoContent} 
          lang={pageContext.i18n.language} 
          googleStructuredData={googleStructuredData}
        />
        <Hero />
        <Guide />
        <Faq />
        <Contact />
        <DiscountPopup location={pageContext.content} />
      </Layout>
    )
  }
}
export default withTranslation(['landing'])(HomePage)
export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
